import React, { useState } from 'react';
import Papa from 'papaparse';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { bulkCreateUsersAPI } from '../services/serverService';

// const JOB_TITLES_FALLBACK = ['Care Worker', 'Senior Carer', 'Nurse', 'Manager', 'Coordinator'];

const validServiceUserPaths = [
    'aboutMe', 'activeLocation.geohash', 'activeLocation.geopoint', 'activeNow',
    'address.country', 'address.county', 'address.firstLineOfAddress', 'address.postalCode', 'address.secondLineOfAddress', 'address.town', 'address.fullAddress',
    'adminID', 'assignedStaffs', 'bankAddress', 'bankDetails.accountName', 'bankDetails.accountNumber', 'bankDetails.bank', 'bankDetails.fullName', 'bankDetails.sortCode',
    'billInformationContact.address', 'billInformationContact.email', 'billInformationContact.name', 'billInformationContact.phone', 'billInformationContact.relation',
    'briefHistory', 'charge.additionalItems', 'charge.authorityBillingCounty', 'charge.authorityBillingUserId', 'charge.authoritybillingAddress', 'charge.authoritybillingAddress2', 'charge.authoritybillingAddress3', 'charge.authoritybillingContactName', 'charge.authoritybillingEmailName', 'charge.authoritybillingName', 'charge.authoritybillingPostcode', 'charge.authoritybillingTelName', 'charge.authoritybillingTown', 'charge.bankHolidayHourlyCharge', 'charge.bankHolidayfourtyfiveCharge', 'charge.bankfifteenCharge', 'charge.bankthirtyCharge', 'charge.chirstmasFifteenCharge', 'charge.christmasHolidayDates', 'charge.christmasHolidayfourtyfiveCharge', 'charge.christmasHourlyCharge', 'charge.christmasThirtyCharge', 'charge.fifteenMinCharge', 'charge.fourtyfiveMinCharge', 'charge.isBankHoliday', 'charge.isChristmasHoliday', 'charge.isNewYearHoliday', 'charge.mileageCharge', 'charge.newYearHoliday', 'charge.nyFifteenCharge', 'charge.nyFourtyfiveCharge', 'charge.nyHourlyCharge', 'charge.nyThirtyCharge', 'charge.primaryFifteenCharge', 'charge.primaryFourtyfiveCharge', 'charge.primaryFrequency', 'charge.primaryHourlyCharge', 'charge.primaryThirtyCharge', 'charge.secondaryFrequency', 'charge.secondaryHourlyCharge', 'charge.sixtyMinHourlyCharge', 'charge.thirdFrequency', 'charge.thirdHourlyCharge', 'charge.thirtyMinHourlyCharge', 'charge.timeTravelRate',
    'convertedFromLead', 'dnacpr', 'dob', 'email', 'ethnicity', 'fullName', 'fundingBody.fundingType', 'gender', 'homeLocation', 'keycode', 'knownAs', 'lastSeen', 'maritalStatus', 'maxCareHoursPerDay', 'maxCareHoursPerMonth', 'maxCareHoursPerWeek', 'maxCareHoursPerYear', 'mentalState', 'messageTokenAndroid', 'messageTokenIOS', 'middleName', 'nationality', 'nextOfKin.address', 'nextOfKin.email', 'nextOfKin.name', 'nextOfKin.phone', 'nextOfKin.relation', 'nhsNumber', 'niNumber', 'phoneCode', 'phoneNumber', 'poa', 'preferredGender', 'preferredLanguage', 'profilePicture', 'reactivateDate', 'region', 'religion', 'secondaryTel', 'sexualOrientation', 'serviceUserID', 'socialWorker.address', 'socialWorker.email', 'socialWorker.emergencyContact', 'socialWorker.name', 'socialWorker.organisation', 'socialWorker.phone', 'socialWorker.relation', 'socialWorker.responsibilities', 'status', 'terminatedDate', 'totalPay', 'totalVisits', 'type', 'uid', 'underRegularCheck', 'username', 'visitAnalytics.early', 'visitAnalytics.late', 'visitAnalytics.missed', 'visitAnalytics.total'
];

const validEmployeePaths = [
    'activeLocation.geohash', 'activeLocation.geopoint', 'homeLocation', 'activeNow', 'isTravelling', 'onBreak', 'onTheClock', 'lastSeen',
    'address.country', 'address.county', 'address.firstLineOfAddress', 'address.postalCode', 'address.secondLineOfAddress', 'address.town',
    'dob', 'gender', 'phoneCode', 'profilePicture', 'adminID', 'currentShiftID', 'left', 'status', 'startDate', 'type',
    'bankDetails.accountName', 'bankDetails.accountNumber', 'bankDetails.bank', 'bankDetails.fullName', 'bankDetails.sortCode',
    'carInsurance.expiryDate', 'carInsurance.file', 'dbs.expiryDate', 'dbs.file',
    'driversLicense.DVLA.dvlaCheckAt', 'driversLicense.DVLA.dvlaCheckBy', 'driversLicense.DVLA.dvlaDesc',
    'driversLicense.awardDate', 'driversLicense.dvlaCheck', 'driversLicense.dvlaRestriction', 'driversLicense.expiryDate', 'driversLicense.file', 'driversLicense.issueDate', 'driversLicense.licenseCategory', 'driversLicense.licenseNumber', 'driversLicense.licenseReviewDate', 'driversLicense.penaltyPoints',
    'employeeDetails.employeeID', 'employeeDetails.leaves.TotalAnnualLeavesGranted', 'employeeDetails.leaves.TotalMaternityLeavesGranted', 'employeeDetails.leaves.TotalPaternityLeavesGranted', 'employeeDetails.leaves.TotalSickLeavesGranted', 'employeeDetails.leaves.TotalUnauthorisedLeavesGranted', 'employeeDetails.leaves.annualLeaveRemaining', 'employeeDetails.leaves.maternityLeaveRemaining', 'employeeDetails.leaves.paternityLeaveRemaining', 'employeeDetails.leaves.sickLeaveRemaining', 'employeeDetails.leaves.totalAnnualLeaves', 'employeeDetails.leaves.totalMaternityLeaves', 'employeeDetails.leaves.totalPaternityLeaves', 'employeeDetails.leaves.totalSickLeaves', 'employeeDetails.leaves.totalUnauthorisedLeaves', 'employeeDetails.leaves.unauthorisedLeaveRemaining',
    'rate.annualLeave.hourly', 'rate.bankHoliday.15min', 'rate.bankHoliday.30min', 'rate.bankHoliday.45min', 'rate.bankHoliday.hourly', 'rate.bankHoliday.region', 'rate.christmasHoliday.15min', 'rate.christmasHoliday.30min', 'rate.christmasHoliday.45min', 'rate.christmasHoliday.hourly', 'rate.frequency', 'rate.hourlyRate', 'rate.mileage', 'rate.training', 'rate.travelTimeRate', 'rate.waitingTime',
    'rating', 'ratingCount', 'messageTokenAndroid', 'messageTokenIOS', 'messageTokenWeb',
    'fullName', 'email', 'phoneNumber', 'password', 'jobTitle', 'niNumber', 'primaryRegionalTag', 'primaryRegionalTagId', 'secondaryRegionalTag', 'secondaryRegionalTagId'
];

const BulkUploadModal = ({ serverId, role, closeModal, refreshList }) => {
    const [parsedData, setParsedData] = useState([]);
    const [uploadedHeaders, setUploadedHeaders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [results, setResults] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [failedEntriesModal, setFailedEntriesModal] = useState(null);



    const handleDownloadTemplate = () => {
        let csvContent = "Name,Email,Phone Number\n";
        if (role === 'admin') {
            csvContent = "Name,Email,Phone Number,Permissions\n";
        } else if (role === 'serviceUser' || role === 'employee') {
            csvContent = "fullName,email,phoneNumber\n";
        }
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${role}_upload_template.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const setDeep = (obj, path, value) => {
        if (!path) return;
        const parts = path.split('.');
        let current = obj;
        for (let i = 0; i < parts.length - 1; i++) {
            if (!current[parts[i]]) current[parts[i]] = {};
            current = current[parts[i]];
        }
        current[parts[parts.length - 1]] = value;
    };

    const flattenObject = (ob) => {
        let toReturn = {};
        for (let i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if (i === '_error' || i === '_serverError' || i === 'passcode') continue;
            if (typeof ob[i] === 'object' && ob[i] !== null && !Array.isArray(ob[i])) {
                let flatObject = flattenObject(ob[i]);
                for (let x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[i + '.' + x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    };

    // --- PRE-VALIDATION LOGIC ---
    const validateRow = (row) => {
        if (!row.fullName || String(row.fullName).trim() === '') return 'Name is required.';
        if (!row.email || String(row.email).trim() === '') return 'Email is required.';

        if (role === 'admin') {
            const phoneDigits = row.phoneNumber ? String(row.phoneNumber).replace(/\D/g, '') : '';
            if (phoneDigits.length < 10 && phoneDigits.length > 0) return 'Phone number too short.';
            if (phoneDigits.length === 0) return 'Phone number is required.';
        }
        return null;
    };

    // --- 2. CSV PARSER & SMART AUTO-GENERATOR ---
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: 'greedy',
            complete: (results) => {
                const rows = results.data;
                const headers = results.meta.fields;
                setUploadedHeaders(headers.map(h => h.trim()));

                if (role === 'serviceUser' || role === 'employee') {
                    const validPaths = role === 'serviceUser' ? validServiceUserPaths : validEmployeePaths;
                    // 1. Strict Schema Header Check
                    const invalidHeaders = headers.filter(h => !validPaths.includes(h.trim()) && h.trim() !== 'Error Reason');
                    if (invalidHeaders.length > 0) {
                        alert(`Upload Aborted.\nInvalid column names found: ${invalidHeaders.join(', ')}.\nPlease update column names to exactly match the boilerplate keys (e.g., 'fullName', not 'FullName').`);
                        e.target.value = null;
                        return;
                    }

                    // 2. Duplicate Email Check within CSV
                    const emails = rows.map(r => String(r.email || '').trim().toLowerCase()).filter(e => e !== '');
                    const duplicateEmails = emails.filter((item, index) => emails.indexOf(item) !== index);
                    if (duplicateEmails.length > 0) {
                        alert(`Upload Aborted.\nDuplicate emails found within the sheet: ${duplicateEmails[0]}.\nEmails must be unique.`);
                        e.target.value = null;
                        return;
                    }

                    // 3. Empty Mandatory Fields Pre-check
                    const hasEmptyFields = rows.some(r => {
                        const nameStr = String(r.fullName || '').trim();
                        const emailStr = String(r.email || '').trim();
                        if (role === 'employee') {
                            return emailStr === '' || nameStr === '' || !/[a-zA-Z]/.test(nameStr);
                        } else {
                            // serviceUser
                            return nameStr === '' || !/[a-zA-Z]/.test(nameStr);
                        }
                    });

                    if (hasEmptyFields) {
                        if (role === 'employee') {
                            alert(`Upload Aborted.\nOne or more rows are missing a valid 'fullName' or 'email'.\nPlease ensure all rows have both, and that the name contains letters.`);
                        } else {
                            alert(`Upload Aborted.\nOne or more rows are missing a valid 'fullName'.\nPlease ensure all rows have a name containing letters.`);
                        }
                        e.target.value = null;
                        return;
                    }
                }

                const processedRows = rows.map(row => {
                    let newRow = {};

                    if (role === 'serviceUser' || role === 'employee') {
                        const validPaths = role === 'serviceUser' ? validServiceUserPaths : validEmployeePaths;
                        Object.keys(row).forEach(key => {
                            const trimmedKey = key.trim();
                            if (validPaths.includes(trimmedKey) || trimmedKey === 'Error Reason') {
                                let val = row[key];
                                if (trimmedKey === 'isTravelling') {
                                    if (val === undefined || val === null || val === '') return;
                                    const strVal = String(val).trim().toLowerCase();
                                    if (strVal === 'true') val = true;
                                    else if (strVal === 'false') val = false;
                                    else return;
                                }
                                setDeep(newRow, trimmedKey, val);
                            }
                        });
                        if (!newRow.fullName) newRow.fullName = '';
                        if (!newRow.email) newRow.email = '';
                    } else {
                        const fullName = (row['Name'] || row.fullName || row.full_name || '').trim();
                        const phone = (row['Phone Number'] || row.phoneNumber || row.phone || '').trim();
                        const email = (row['Email'] || row.email || '').trim();
                        const permissions = (row['Permissions'] || row.permissions || row.permission || '').trim();
                        newRow = { fullName, phoneNumber: phone, email };
                        if (role === 'admin') newRow.permissions = permissions;
                    }

                    const randomNum = Math.floor(10000 + Math.random() * 90000);
                    newRow.passcode = `Architecture${randomNum}!`;
                    newRow._error = validateRow(newRow);
                    return newRow;
                });

                const finalRows = processedRows.filter(r => {
                    if (role === 'employee') return r.fullName !== '' && r.email !== '';
                    if (role === 'serviceUser') return r.fullName !== '';
                    return r.fullName !== '';
                });
                setParsedData(finalRows);
                e.target.value = null;
            }
        });
    };

    // --- Handle Cell Edit ---
    const handleCellEdit = (index, field, value) => {
        const updated = [...parsedData];
        const newRow = JSON.parse(JSON.stringify(updated[index])); // Deep clone to avoid mutating state directly

        if (role === 'serviceUser' || role === 'employee') {
            let finalValue = value;
            if (field === 'isTravelling') {
                const strVal = String(value).trim().toLowerCase();
                if (strVal === 'true') finalValue = true;
                else if (strVal === 'false') finalValue = false;
            }
            setDeep(newRow, field, finalValue);
        } else {
            newRow[field] = value;
        }

        newRow._error = validateRow(newRow);
        newRow._serverError = null; // Clear server error on edit to reset UI
        updated[index] = newRow;
        setParsedData(updated);
    };

    const handleImportClick = () => {
        if (parsedData.length === 0) return alert("No valid data to import.");

        const invalidRowsCount = parsedData.filter(r => r._error).length;

        if (invalidRowsCount > 0) {
            setShowConfirmModal(true);
        } else {
            executeBulkCreate(parsedData);
        }
    };

    const executeBulkCreate = async (dataToProcess) => {
        setShowConfirmModal(false);
        setIsLoading(true);

        const payloadArray = dataToProcess.map(row => {
            const { _error, _serverError, ...rowPayload } = row;
            return rowPayload;
        });

        try {
            const response = await bulkCreateUsersAPI({ targetServerId: serverId, usersArray: payloadArray, role: role });
            const { successCount, createdUsers, errors } = response.data.data;

            if (successCount > 0) refreshList();

            if (errors && errors.length > 0) {
                // Identify failed rows based on precise global index (with fallback to name)
                const failedRows = [];
                dataToProcess.forEach((row, index) => {
                    const err = errors.find(e => e.index === index || (e.index === undefined && e.name === row.fullName) || (e.index === undefined && e.name === 'Unknown' && !row.fullName));
                    if (err) {
                        failedRows.push({ ...row, _serverError: err.reason });
                    }
                });

                const previouslySkippedRows = parsedData.filter(r => r._error);

                // Keep the failed/skipped rows in the UI for in-browser correction
                setParsedData([...failedRows, ...previouslySkippedRows]);
                setFailedEntriesModal({ successCount, failCount: failedRows.length, errors, createdUsers });
            } else {
                // Complete success
                setResults({ successCount, createdUsers, errors });
                const previouslySkippedRows = parsedData.filter(r => r._error);
                setParsedData(previouslySkippedRows);
            }

        } catch (error) {
            console.error("Bulk Upload Error:", error);
            alert("Upload failed: " + (error.message || "Server Error"));
        } finally {
            setIsLoading(false);
        }
    };

    const downloadFailedCSV = () => {
        const csvData = parsedData.map(row => {
            if (role === 'serviceUser' || role === 'employee') {
                return {
                    ...flattenObject(row),
                    'Error Reason': row._serverError || row._error || 'Unknown Error'
                };
            }
            return {
                Name: row.fullName,
                Email: row.email,
                'Phone Number': row.phoneNumber,
                'Error Reason': row._serverError || row._error || 'Unknown Error'
            };
        });

        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `failed_${role}_entries_${new Date().getTime()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadSuccessCSV = (createdUsersArray) => {
        if (!createdUsersArray || createdUsersArray.length === 0) return;
        const csvData = createdUsersArray.map(user => {
            return {
                Name: user.fullName || "N/A",
                Email: user.email || "N/A",
                Phone: user.phoneNumber || "N/A",
                Username: user.newUsername,
                Password: user.plainTextPassword
            };
        });

        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `successful_${role}_entries_${new Date().getTime()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // --- 4. PDF GENERATOR ---
    const downloadPDF = (createdUsersArray) => {
        if (!createdUsersArray || createdUsersArray.length === 0) return;
        const doc = new jsPDF();

        doc.setFontSize(18);
        doc.text(`Created ${role.toUpperCase()} Credentials`, 14, 22);
        doc.setFontSize(11);
        doc.setTextColor(100);
        doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

        const tableColumn = ["Name", "Email", "Phone", "Username", "Password"];
        const tableRows = createdUsersArray.map(user => [
            user.fullName || "N/A",
            user.email || "N/A",
            user.phoneNumber || "N/A",
            user.newUsername,
            user.plainTextPassword
        ]);

        autoTable(doc, {
            head: [tableColumn], body: tableRows, startY: 35, theme: 'grid', styles: { fontSize: 9, cellPadding: 3 }, headStyles: { fillColor: [43, 108, 176] },
        });

        doc.save(`${role}_credentials_${new Date().getTime()}.pdf`);
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '12px', width: '90%', maxWidth: '1000px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '15px', marginBottom: '20px' }}>
                    <h2 style={{ margin: 0, color: '#2d3748', textTransform: 'capitalize' }}>Bulk Import {role}s</h2>
                    <button onClick={closeModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#a0aec0' }}>&times;</button>
                </div>

                {!results ? (
                    <div style={{ flex: 1, overflowY: 'auto' }}>

                        <div style={{ backgroundColor: '#ebf8ff', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #bee3f8' }}>
                            <p style={{ margin: '0 0 10px 0', color: '#2b6cb0', fontWeight: 'bold' }}>Step 1: Use the simple {role === 'serviceUser' || role === 'employee' ? 'boilerplate' : '3-column'} template</p>
                            <button onClick={handleDownloadTemplate} style={{ padding: '8px 16px', backgroundColor: 'white', border: '1px solid #cbd5e0', borderRadius: '4px', cursor: 'pointer', marginRight: '15px', fontWeight: 'bold' }}>
                                ⬇️ Download Template ({role === 'serviceUser' || role === 'employee' ? 'fullName, email...' : 'Name, Email, Phone'})
                            </button>
                            <span style={{ fontSize: '14px', color: '#4a5568' }}>Emails are REQUIRED for all roles.</span>
                        </div>

                        <div style={{ backgroundColor: '#f7fafc', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #e2e8f0' }}>
                            <p style={{ margin: '0 0 10px 0', color: '#4a5568', fontWeight: 'bold' }}>Step 3: Upload CSV Data</p>
                            <input type="file" accept=".csv" onChange={handleFileUpload} style={{ padding: '10px', width: '100%', cursor: 'pointer' }} />
                        </div>

                        {/* --- Editable Input Fields in Preview Table --- */}
                        {parsedData.length > 0 && (
                            <div>
                                <h3 style={{ fontSize: '16px', color: '#2d3748', marginBottom: '10px' }}>
                                    Preview ({parsedData.length} entries)
                                    {parsedData.filter(r => r._error || r._serverError).length > 0 &&
                                        <span style={{ color: '#e53e3e', marginLeft: '10px', fontSize: '14px' }}>
                                            ({parsedData.filter(r => r._error || r._serverError).length} errors found)
                                        </span>
                                    }
                                </h3>
                                <div style={{ overflowX: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px', maxHeight: '300px' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                                        <thead style={{ backgroundColor: '#f7fafc', borderBottom: '2px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 10 }}>
                                            <tr>
                                                {role === 'serviceUser' || role === 'employee' ? (
                                                    uploadedHeaders.map((header, idx) => (
                                                        <th key={idx} style={{ padding: '10px', textAlign: 'left', minWidth: '150px' }}>{header}</th>
                                                    ))
                                                ) : (
                                                    <>
                                                        <th style={{ padding: '10px', textAlign: 'left', width: '25%' }}>Name</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', width: '25%' }}>Email</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', width: '25%' }}>Phone</th>
                                                    </>
                                                )}
                                                <th style={{ padding: '10px', textAlign: 'left', width: '25%' }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {parsedData.map((row, index) => {
                                                const hasError = !!row._error || !!row._serverError;
                                                const errorMsg = row._serverError || row._error;
                                                const flatRow = (role === 'serviceUser' || role === 'employee') ? flattenObject(row) : row;

                                                return (
                                                    <tr key={index} style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: hasError ? '#fff5f5' : 'transparent' }}>
                                                        {role === 'serviceUser' || role === 'employee' ? (
                                                            uploadedHeaders.map((header, idx) => {
                                                                const isRequired = (header === 'fullName' || header === 'email');
                                                                const val = flatRow[header] !== undefined ? flatRow[header] : '';
                                                                return (
                                                                    <td key={idx} style={{ padding: '8px' }}>
                                                                        <input
                                                                            type="text"
                                                                            value={val}
                                                                            onChange={(e) => handleCellEdit(index, header, e.target.value)}
                                                                            style={{ width: '100%', padding: '6px', border: `1px solid ${(isRequired && !val) ? '#e53e3e' : '#cbd5e0'}`, borderRadius: '4px' }}
                                                                        />
                                                                    </td>
                                                                );
                                                            })
                                                        ) : (
                                                            <>
                                                                <td style={{ padding: '8px' }}>
                                                                    <input
                                                                        type="text"
                                                                        value={row.fullName}
                                                                        onChange={(e) => handleCellEdit(index, 'fullName', e.target.value)}
                                                                        style={{ width: '100%', padding: '6px', border: `1px solid ${!row.fullName ? '#e53e3e' : '#cbd5e0'}`, borderRadius: '4px' }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '8px' }}>
                                                                    <input
                                                                        type="text"
                                                                        value={row.email}
                                                                        onChange={(e) => handleCellEdit(index, 'email', e.target.value)}
                                                                        style={{ width: '100%', padding: '6px', border: `1px solid ${!row.email ? '#e53e3e' : '#cbd5e0'}`, borderRadius: '4px' }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '8px' }}>
                                                                    <input
                                                                        type="text"
                                                                        value={row.phoneNumber}
                                                                        onChange={(e) => handleCellEdit(index, 'phoneNumber', e.target.value)}
                                                                        style={{ width: '100%', padding: '6px', border: `1px solid ${(!row.phoneNumber || row.phoneNumber.length < 10) ? '#e53e3e' : '#cbd5e0'}`, borderRadius: '4px' }}
                                                                    />
                                                                </td>
                                                            </>
                                                        )}
                                                        <td style={{ padding: '8px', color: hasError ? '#e53e3e' : '#38a169', fontWeight: '500', fontSize: '12px' }}>
                                                            {hasError ? `⚠️ ${errorMsg}` : '✅ Ready'}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    // --- SUCCESS COMPLETE VIEW ---
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ fontSize: '50px', marginBottom: '10px' }}>✅</div>
                        <h2 style={{ margin: '0 0 10px 0', color: '#2d3748' }}>Import Complete</h2>
                        <p style={{ fontSize: '18px', color: '#4a5568', margin: '0 0 20px 0' }}>Successfully created <strong style={{ color: '#38a169' }}>{results.successCount}</strong> accounts.</p>

                        {results.successCount > 0 && (
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <button onClick={() => downloadSuccessCSV(results.createdUsers)} style={{ padding: '12px 24px', backgroundColor: '#38a169', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer', boxShadow: '0 4px 6px rgba(56, 161, 105, 0.3)' }}>
                                    📊 Download CSV Details
                                </button>
                                <button onClick={() => downloadPDF(results.createdUsers)} style={{ padding: '12px 24px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer', boxShadow: '0 4px 6px rgba(49, 130, 206, 0.3)' }}>
                                    📄 Download PDF Credentials
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {/* --- BOTTOM ACTION BAR --- */}
                <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button onClick={closeModal} style={{ padding: '10px 20px', backgroundColor: 'white', border: '1px solid #cbd5e0', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', color: '#4a5568' }}>
                        {results ? 'Close' : 'Cancel'}
                    </button>
                    {!results && (
                        <button
                            onClick={handleImportClick}
                            disabled={isLoading || parsedData.length === 0}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: parsedData.length > 0 ? '#38a169' : '#a0aec0',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: (isLoading || parsedData.length === 0) ? 'not-allowed' : 'pointer',
                                fontWeight: 'bold'
                            }}>
                            {isLoading ? 'Processing...' : (parsedData.length > 0 ? `Import ${parsedData.length} Accounts` : 'Import Accounts')}
                        </button>
                    )}
                </div>

                {/* --- CUSTOM MODALS OVERLAYS --- */}

                {/* 1. Pre-Validation Skip Modal */}
                {showConfirmModal && (
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.9)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000, borderRadius: '12px' }}>
                        <div style={{ backgroundColor: 'white', padding: '25px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', maxWidth: '450px', textAlign: 'center' }}>
                            <div style={{ fontSize: '40px', marginBottom: '10px' }}>⚠️</div>
                            <h3 style={{ margin: '0 0 10px 0', color: '#2d3748' }}>Invalid Entries Detected</h3>
                            <p style={{ color: '#4a5568', marginBottom: '20px' }}>
                                There are <strong>{parsedData.filter(r => r._error).length}</strong> rows with errors. <br />
                                Would you like to skip the invalid rows and only upload the <strong>{parsedData.filter(r => !r._error).length}</strong> correct ones?
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                <button onClick={() => setShowConfirmModal(false)} style={{ padding: '8px 16px', backgroundColor: 'white', border: '1px solid #cbd5e0', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>Cancel & Fix</button>
                                <button onClick={() => executeBulkCreate(parsedData.filter(r => !r._error))} style={{ padding: '8px 16px', backgroundColor: '#e53e3e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                                    Skip Errors & Upload Valid
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* 2. Post-Upload Failed Entries Modal */}
                {failedEntriesModal && (
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.95)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000, borderRadius: '12px' }}>
                        <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 10px 25px rgba(0,0,0,0.15)', maxWidth: '500px', textAlign: 'center' }}>
                            <div style={{ fontSize: '40px', marginBottom: '10px' }}>⚠️</div>
                            <h3 style={{ margin: '0 0 10px 0', color: '#c53030' }}>Partial Import Success</h3>
                            <p style={{ color: '#4a5568', marginBottom: '10px' }}>
                                Successfully imported <strong style={{ color: '#38a169' }}>{failedEntriesModal.successCount}</strong> accounts.
                            </p>
                            <p style={{ color: '#4a5568', marginBottom: '20px' }}>
                                However, <strong>{failedEntriesModal.failCount}</strong> entries were rejected by the server (e.g. duplicate emails or invalid data).
                                The failed entries have been kept in the table behind this prompt so you can edit and retry them.
                            </p>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <button onClick={downloadFailedCSV} style={{ padding: '10px 16px', backgroundColor: '#edf2f7', border: '1px solid #cbd5e0', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', color: '#2d3748' }}>
                                    ⬇️ Download CSV of Failed Entries
                                </button>
                                {failedEntriesModal.successCount > 0 && (
                                    <>
                                        <button onClick={() => downloadSuccessCSV(failedEntriesModal.createdUsers)} style={{ padding: '10px 16px', backgroundColor: '#38a169', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
                                            📊 Download CSV for Successful ({failedEntriesModal.successCount})
                                        </button>
                                        <button onClick={() => downloadPDF(failedEntriesModal.createdUsers)} style={{ padding: '10px 16px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
                                            📄 Download PDF Credentials for Successful ({failedEntriesModal.successCount})
                                        </button>
                                    </>
                                )}
                                <button onClick={() => setFailedEntriesModal(null)} style={{ padding: '10px 16px', backgroundColor: '#38a169', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', marginTop: '10px' }}>
                                    Go Back & Fix Failed Entries In-Browser
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default BulkUploadModal;